import portableEquipmentImage from '@/assets/images/insurance/portable-equipment.png'
import autoInsuranceImage from '@/assets/images/insurance/auto.png'
import residentialInsuranceImage from '@/assets/images/insurance/residential.png'
import travelInsuranceImage from '@/assets/images/insurance/travel.png'
import lifeInsuranceImage from '@/assets/images/insurance/life.png'
import rcpDoctorsImage from '@/assets/images/insurance/rcp-doctors.jpg'
import { InsuranceProduct } from './insurance.types'

const PRODUCT_DISCLAIMER =
  'As coberturas e valores acima são um resumo. Os detalhes do seu plano aparecem na proposta e nas condições gerais antes de você contratar.'

export const INSURANCE_PRODUCTS: InsuranceProduct[] = [
  {
    id: 'rcp-doctors',
    title: 'Seguro de Responsabilidade Civil Profissional da Saúde',
    subtitle:
      'Proteção financeira e jurídica para o exercício da sua profissão.',
    description:
      'O seguro RCP protege você contra reclamações de pacientes ou terceiros por prejuízos causados por erros ou omissões no exercício da sua atividade profissional. Coberturas de R$ 100.000 a R$ 1.500.000.',
    image: rcpDoctorsImage,
    imageAlt: 'Médico em uniforme azul com escudo de proteção no celular',
    imagePosition: 'center 45%',
    coverageTitle: 'Principais coberturas',
    coveredItems: [
      'Custos de defesa cível, administrativa e criminal',
      'Assistência jurídica, acordo judicial ou extrajudicial',
      'Danos à reputação/imagem',
      'Honorários, perícias, sucumbência e eventual condenação',
    ],
    benefits: [
      'Reduz o desgaste financeiro e emocional de um processo, mesmo quando a acusação é infundada',
      'Atende médicos, psicólogos, dentistas, fisioterapeutas, nutricionistas e outros profissionais da saúde',
      'Contratado na pessoa física, com extensão de cobertura para a sua PJ',
      'Contratação e simulação online'
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateRoute: '/insurance/rcp-medicos',
  },
  {
    id: 'residential',
    title: 'Seguro Residencial',
    subtitle: 'Proteção para a sua casa, sem pesar no bolso.',
    description:
      'O Residencial Essencial é a versão mais enxuta do seguro residencial da Porto. Cobre os problemas que dão mais dor de cabeça — incêndio, explosão, queda de raio e curto que queima aparelhos — e ainda manda ajuda quando você precisa de chaveiro, encanador ou eletricista.',
    image: residentialInsuranceImage,
    imageAlt: 'Casal segurando uma miniatura de casa',
    imagePosition: 'center 25%',
    coverageTitle: 'O que costuma estar coberto',
    coveredItems: [
      'Incêndio, explosão, queda de raio e fumaça',
      'Danos elétricos nos seus aparelhos',
      'Prejuízos que você cause sem querer a vizinhos ou a terceiros',
      'Assistência 24h para reparos do dia a dia',
    ],
    benefits: [
      'Funciona para imóvel próprio ou alugado',
      'Você usa as assistências mesmo quando nada dá errado',
      'Dá para ajustar os valores ao tamanho e ao conteúdo da sua casa',
      'Solicitação 100% online, sem precisar sair do app',
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateUrl:
      'https://www.portoseguro.com.br/loja/seguro-residencial?link_uuid=a22a01f7-9b44-477c-9c50-af1e5ef76ab9&social_media=OTHERS&source=NEW_ENGINE&susep=CO3C0J&origem=gerador-link_corretor&utm_id=a22a01f7-9b44-477c-9c50-af1e5ef76ab9&utm_source=gerador-link-corretor&utm_medium=others&utm_campaign=CO3C0J&utm_content=residenciaessencial',
  },
  {
    id: 'life',
    title: 'Seguro de Vida',
    subtitle: 'Um cuidado com quem você ama, montado do seu jeito.',
    description:
      'O Vida On é o seguro de vida que você monta como quiser: escolhe as coberturas que fazem sentido para o seu momento e garante que, se algo acontecer com você, a sua família tenha um apoio para seguir em frente. Tudo online, sem burocracia.',
    image: lifeInsuranceImage,
    imageAlt: 'Mãos protegendo uma família e um coração',
    imagePosition: 'center 35%',
    coverageTitle: 'O que você pode incluir',
    coveredItems: [
      'Amparo financeiro para a família em caso de falecimento',
      'Proteção em caso de invalidez por acidente',
      'Apoio diante de doenças graves',
      'Assistências como funeral e apoio à família',
    ],
    benefits: [
      'Você paga só pelas coberturas que escolher',
      'Dá para começar simples e ajustar quando quiser',
      'Não é só sobre falecimento: várias coberturas protegem você ainda em vida',
      'Solicitação 100% online, sem precisar sair do app',
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateUrl:
      'https://www.portoseguro.com.br/loja/seguro-de-vida?link_uuid=af64ae53-89b6-452d-8aee-1b85b5e33705&social_media=OTHERS&source=NEW_ENGINE&susep=CO3C0J&origem=gerador-link_corretor&utm_id=af64ae53-89b6-452d-8aee-1b85b5e33705&utm_source=gerador-link-corretor&utm_medium=others&utm_campaign=CO3C0J&utm_content=segurodevidaon',
  },
  {
    id: 'travel',
    title: 'Seguro Viagem',
    subtitle: 'Viaje tranquilo, do check-in ao retorno.',
    description:
      'O Seguro Viagem cobre os perrengues que podem estragar uma viagem — uma consulta médica fora do país, uma bagagem que não chega, um voo cancelado. Vale para viagens nacionais e internacionais, a lazer ou a trabalho.',
    image: travelInsuranceImage,
    imageAlt: 'Duas pessoas viajando com malas',
    imagePosition: 'center 20%',
    coverageTitle: 'O que costuma estar coberto',
    coveredItems: [
      'Despesas médicas e hospitalares durante a viagem',
      'Bagagem extraviada ou danificada',
      'Cancelamento ou atraso de voo',
      'Assistência 24h em português, onde você estiver',
    ],
    benefits: [
      'Vários destinos, como os países do Tratado de Schengen, exigem seguro viagem para liberar a entrada',
      'Você contrata só para os dias da viagem',
      'A ajuda fica a uma ligação de distância, em qualquer fuso horário',
      'Solicitação 100% online, sem precisar sair do app',
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateUrl:
      'https://www.portoseguro.com.br/loja/seguro-viagem?link_uuid=180784c7-646f-4c81-8b7d-2c45d601fba5&social_media=OTHERS&source=NEW_ENGINE&susep=CO3C0J&origem=gerador-link_corretor&utm_id=180784c7-646f-4c81-8b7d-2c45d601fba5&utm_source=gerador-link-corretor&utm_medium=others&utm_campaign=CO3C0J&utm_content=viagem',
  },
  {
    id: 'portable-equipment',
    title: 'Seguro para Equipamentos Portáteis',
    subtitle:
      'Seu celular, computador e seus equipamentos protegidos onde você for.',
    description:
      'Celular, notebook, tablet, câmera: os aparelhos que você carrega todo dia também correm risco de queda, roubo e furto. Esse seguro protege esses equipamentos dentro e fora de casa.',
    image: portableEquipmentImage,
    imageAlt: 'Celular com símbolo de proteção digital',
    imagePosition: 'center 40%',
    coverageTitle: 'O que costuma estar coberto',
    coveredItems: [
      'Roubo e furto qualificado',
      'Danos acidentais, como quedas e contato com líquidos',
      'Proteção dentro e fora de casa',
      'Vários aparelhos em uma mesma contratação',
    ],
    benefits: [
      'Conserto ou troca sem pesar de uma vez no orçamento',
      'Protege quem trabalha com o equipamento na rua',
      'Você escolhe quais aparelhos entram',
      'Solicitação 100% online, sem precisar sair do app',
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateUrl:
      'https://www.portoseguro.com.br/equipamentos-portateis/corretor?link_uuid=8a293102-3719-4dbc-abfe-132070ac5abc&social_media=OTHERS&source=NEW_ENGINE&susep=CO3C0J&origem=gerador-link_corretor&utm_id=8a293102-3719-4dbc-abfe-132070ac5abc&utm_source=gerador-link-corretor&utm_medium=others&utm_campaign=CO3C0J&utm_content=equipamentosportateis',
  },
  {
    id: 'auto',
    title: 'Porto Seguro Automóvel',
    subtitle: 'Rode tranquilo, com a Porto cuidando do seu carro.',
    description:
      'O Porto Seguro Auto protege o seu veículo em caso de batida, roubo, furto e incêndio, e ainda cobre os prejuízos que você possa causar a outras pessoas no trânsito. Tudo com a rede de oficinas e a assistência que fizeram o nome da Porto.',
    image: autoInsuranceImage,
    imageAlt: 'Mãos protegendo uma miniatura de automóvel',
    imagePosition: 'center 45%',
    coverageTitle: 'O que costuma estar coberto',
    coveredItems: [
      'Colisão, incêndio, roubo e furto do veículo',
      'Danos que você cause a outros veículos e pessoas',
      'Guincho, chaveiro e carro reserva (conforme o plano)',
      'Vidros, faróis e retrovisores (conforme o plano)',
    ],
    benefits: [
      'Rede ampla de oficinas credenciadas',
      'Assistência 24h em todo o país',
      'Você escolhe as coberturas e serviços que combinam com a sua rotina',
      'Solicitação 100% online, sem precisar sair do app',
    ],
    disclaimer: PRODUCT_DISCLAIMER,
    simulateUrl:
      'https://www.portoseguro.com.br/loja/seguro-auto/placa-do-veiculo?link_uuid=d4ce5e4b-9caa-421e-ae5e-ef78c926721b&social_media=OTHERS&source=NEW_ENGINE&susep=CO3C0J&origem=gerador-link_corretor&utm_id=d4ce5e4b-9caa-421e-ae5e-ef78c926721b&utm_source=gerador-link-corretor&utm_medium=others&utm_campaign=CO3C0J&utm_content=seguroauto',
  },
]
